import { Consumer } from '~/constants/common/consumer';
import { COMPOSER_OPEN_PARAM } from '~/constants/composer';
import type { AppliedFilters } from '~/contracts/common';
import { getHrefWithSource } from '~/hooks/common/selectors/useGetConsumerHref';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';

const getHomeHref = getHrefWithSource(Consumer.HOME);

export default function buildHomeSearchRedirectUrl(
  filters: Partial<AppliedFilters>
): string {
  const searchLink = generateSearchLinkFilter({ filters });
  const href = getHomeHref(searchLink);

  const url = new URL(href, 'https://www.dummy.com');
  url.searchParams.set(COMPOSER_OPEN_PARAM, '1');

  return url.pathname + url.search;
}
